import request, { IWorkspaceResponse } from '/@/api/http/request'
import { DeviceCmd, DeviceCmdItemAction } from '/@/types/device-cmd'
import { getDrcControlHeaders } from '/@/utils/drc-lease'

const CMD_API_PREFIX = '/control/api/v1'

export interface SendCmdParams {
  dock_sn: string, // 机场cn
  device_cmd: DeviceCmd // 指令
}

export interface PostSendCmdBody {
  action: DeviceCmdItemAction
}
/**
 * 发送机场控制指令
 * @param params
 * @returns
 */
// /control/api/v1/devices/{dock_sn}/jobs/{service_identifier}
export async function postSendCmd (params: SendCmdParams, body?: PostSendCmdBody, options?: { skipErrorMessage?: boolean }): Promise<IWorkspaceResponse<{}>> {
  const config = {
    ...(options?.skipErrorMessage ? { skipErrorMessage: true } : {}),
    headers: getDrcControlHeaders(params.dock_sn),
  } as any
  const resp = await request.post(`${CMD_API_PREFIX}/devices/${params.dock_sn}/jobs/${params.device_cmd}`, body, config)
  return resp.data
}

export async function powerOnDrone (dockSn: string, options?: { skipErrorMessage?: boolean }): Promise<IWorkspaceResponse<{}>> {
  const config = options?.skipErrorMessage ? { skipErrorMessage: true } as any : undefined
  const resp = await request.post(`${CMD_API_PREFIX}/devices/${dockSn}/drone/open`, undefined, config)
  return resp.data
}
